export default {"src":"/_next/static/media/card-placeholder-4.f4d452f7.svg","height":162,"width":231,"blurWidth":0,"blurHeight":0};